import TemplateView from '../../TemplateView'
import messageResource from '../../messageResource'
import Dropzone from 'dropzone'
import {DROPZONE_REPORT_PARAMETERS} from './constants'

export default class ReportLogoDropzone extends TemplateView {
    constructor({
        onFileLoaded = () => {},
        onCreateThumbnail = (url) => {},

    } = {}) {
        super()

        this.callbacks = {
            onFileLoaded,
            onCreateThumbnail,
        }

        this.state = {
            active: false,
            imageUrl: '',
        }

        this.onStatePropertyChanged('active', (active) => {
            this.getEl().toggleClass('active', active)
        })

        this.onStatePropertyChanged('imageUrl', (imageUrl) => {
            this.$logoPreviewImg.attr('src', imageUrl)
            this.getEl().toggleClass('hasFile', !!imageUrl)
            this.$logoPreview.toggle(!!imageUrl)
        })
    }

    templateHtml() {
        return '        <div class="reportLogoDropzone">' +
               '            <div class="reportLogoPlaceholder">' +
               '                <div class="image"/>' +
               '                <div class="text"><%=placeholderText%></div>' +
               '            </div>' +
               '            <div class="logoPreview">' +
               '                <div class="logoDetails">' +
               '                    <img class="currentLogo"/>' +
               '                </div>' +
               '            </div>' +
               '            <div class="reportLogoDropzonePreviewTemplate dz-preview dz-file-preview"><div></div></div>' +
               '            <div class="uploadAnotherImageButton"><%=uploadAnother%></div>' +
               '        </div>'
    }

    messageKeys() {
        return {
            placeholderText: 'logo_settings.dropzone.placeholder_text',
            uploadAnother: 'logo_settings.dropzone.upload_another',
        }
    }

    afterRender() {
        this.$logoPreview = this.find('.logoPreview')
        this.$logoPreviewImg = this.find('.currentLogo')
        this.find('.reportLogoDropzonePreviewTemplate').hide() // dropzone preview not used here

        this._initDropzone()
        this.find('.uploadAnotherImageButton').on('click', () => {
            this.dropzone.hiddenFileInput.click()
        })

        this.renderInitialState()
    }

    _initDropzone() {
        this.dropzone = new Dropzone('.reportLogoDropzone', {
            previewTemplate: document.querySelector('.reportLogoDropzonePreviewTemplate').innerHTML,
            paramName: 'formCustomReportLogo.logo',
            clickable: '.reportLogoPlaceholder',
            ...DROPZONE_REPORT_PARAMETERS,
            accept: (file, callback) => {
                if (file.size === 0)
                    callback(messageResource.getMessage('contact_support.error.empty_file'))
                else {
                    if (this.dropzone.files[1] != null) {
                        this.dropzone.removeFile(this.dropzone.files[0])
                    }
                    this.callbacks.onFileLoaded()
                    callback()
                }
            },
        })
        this.dropzone.on("maxfilesexceeded", (file) => {
            this.dropzone.removeFile(this.dropzone.files[0])
            this.dropzone.addFile(file)
        })
        this.dropzone.on('error', (file, error) => {
            this._onDropzoneError(file, error)
        })
        this.dropzone.createThumbnailFromUrl = (file, imageUrl, callback, crossOrigin) => {
            if (file.accepted) {
                this.callbacks.onCreateThumbnail(imageUrl)
            }
            if (callback != null) {
                return callback()
            }
        }
    }

    _onDropzoneError(file, errorText) {
        if (file.status !== 'canceled') {
            alert(errorText)
            this.dropzone.removeFile(file)
        }
    }

    hasFile() {
        return this.dropzone.files && this.dropzone.files.length
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/customization/ReportLogoDropzone.js